const Pages = () => {
  return <h1>Pages</h1>;
};
export default Pages;
